import { formatText } from "@ui/format";
import { FormCurrency } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";
import { Form as FinalForm } from "react-final-form";
import "./style.scss";

const MIN_LOAN_AMOUNT = 3_000_000;

export class NhpLandingCalculator extends React.Component {
	public render(): ReactNode {
		return (
			<FinalForm initialValues={{ loanInput: 25_000_000 }} onSubmit={() => undefined}>
				{({ values }) => (
					<div className="nhp-landing-calculator">
						<div className="nhp-landing-calculator-field">
							<FormCurrency
								label="Hitelösszeg:"
								prepend=""
								name="loanInput"
								placeholder=""
								className="mx-1"
								validate={this.validateLoanInput}
								required
								inline
							/>
						</div>
						<table>
							<thead>
								<tr>
									<td>Futamidő</td>
									<td>
										Havi törlesztő
										<span className="calc-info">(tőke + kamat fizetés együtt)</span>
									</td>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>20 év</td>
									<td>
										<span id="year20">
											{formatText((values.loanInput / (20 * 12)) * (1 + 0.025 / 12), "ft")}
										</span>
									</td>
								</tr>
								<tr>
									<td>15 év</td>
									<td>
										<span id="year15">
											{formatText((values.loanInput / (15 * 12)) * (1 + 0.025 / 12), "ft")}
										</span>
									</td>
								</tr>
								<tr>
									<td>10 év</td>
									<td>
										<span id="year10">
											{formatText((values.loanInput / (10 * 12)) * (1 + 0.025 / 12), "ft")}
										</span>
									</td>
								</tr>
								<tr>
									<td>7 év</td>
									<td>
										<span id="year7">
											{formatText((values.loanInput / (7 * 12)) * (1 + 0.025 / 12), "ft")}
										</span>
									</td>
								</tr>
								<tr>
									<td>5 év</td>
									<td>
										<span id="year5">
											{formatText((values.loanInput / (5 * 12)) * (1 + 0.025 / 12), "ft")}
										</span>
									</td>
								</tr>
								<tr>
									<td>3 év</td>
									<td>
										<span id="year3">
											{formatText((values.loanInput / (3 * 12)) * (1 + 0.025 / 12), "ft")}
										</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				)}
			</FinalForm>
		);
	}

	private validateLoanInput(loanInput: number): string {
		if (loanInput < MIN_LOAN_AMOUNT) {
			return `Nem lehet kisebb mint ${MIN_LOAN_AMOUNT / 1_000_000} millió Ft.`;
		}
	}
}
